"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LINK_PRODUCT_TREES = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.LINK_PRODUCT_TREES = (0, gql_1.gql)(`
  mutation LinkProductTrees($parentTreeId: ID!, $childTreeId: ID!) {
    linkProductTrees(input: {
      parentTreeId: $parentTreeId,
      childTreeId: $childTreeId,
      clientMutationId: "",
    }) {
      success
      error
    }
  }
`);
